/**
 * Token Cache — lightweight bridge for token expiry information.
 *
 * Holds the expiry timestamp of the most recently acquired access token so that
 * the API request interceptor (api.client.ts) can perform a cheap synchronous
 * pre-flight check without importing the Redux store (which would create a
 * circular dependency through the store → slice → service → store chain).
 *
 * Updated by useTokenRefresh after every successful acquireTokenSilent call.
 * The Redux `tokenExpiresOn` field remains the persistent/UI source of truth;
 * this module is the ephemeral, non-circular in-memory copy used by the client.
 */

let _tokenExpiresOn: number | null = null;

/** Store the expiry timestamp (Unix ms) of the latest access token. */
export function setTokenExpiresOnCache(ms: number | null): void {
  _tokenExpiresOn = ms;
}

/** Read the cached expiry timestamp (Unix ms), or null if not yet set. */
export function getTokenExpiresOnCache(): number | null {
  return _tokenExpiresOn;
}
